import { useEditor, EditorContent } from '@tiptap/react';
import { narrativeExtensions } from './narrativeExtensions';

/**
 * Read-only Tiptap render of a narrative section's content. Used in the
 * preview modal where we want to show the finished prose without any of
 * the editing chrome (toolbar, Save button, version dropdown).
 *
 * Each instance is its own editor, but Tiptap's read-only mode is light
 * enough that mounting one per section in a preview is fine.
 */
export function NarrativePreview({ contentJson }: { contentJson: string | null }) {
  const editor = useEditor({
    editable: false,
    // Same configuration as the editor, so underline (and anything added
    // later) renders in the preview and the client report viewer.
    extensions: narrativeExtensions(),
    content: parseContent(contentJson),
    editorProps: {
      // Inherit prose styles so headings, lists, links read like a document.
      attributes: { class: 'prose prose-sm max-w-none' },
    },
  });

  if (!contentJson) {
    return (
      <p className="text-sm text-gray-400 italic">
        (No content yet — this section is blank in the report.)
      </p>
    );
  }
  return <EditorContent editor={editor} />;
}

function parseContent(raw: string | null): object | string {
  if (!raw) return '';
  try {
    return JSON.parse(raw);
  } catch {
    return raw;
  }
}
